import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=62becce0&scoped=true"
import script from "./OrderChart.vue?vue&type=script&lang=js"
export * from "./OrderChart.vue?vue&type=script&lang=js"
import style0 from "./OrderChart.vue?vue&type=style&index=0&id=62becce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62becce0",
  null
  
)

export default component.exports